import React from 'react'
import { FeatureImage } from 'js/components/FeatureImage'
import { lpImages } from 'js/pages/LandingPages/imageSources'

type StarsProps = {
  align?: 'left' | 'center'
  size?: 'small' | 'medium' | 'large'
}

const Stars = ({ align = 'center', size = 'medium' }: StarsProps) => {
  const justifyClass = align === 'left' ? 'justify-start' : 'justify-center'

  const sizeClass = {
    small: 'w-[12px] h-[12px]',
    medium: 'w-[16px] h-[16px]',
    large: 'w-[20px] h-[20px]',
  }[size]

  return (
    <div className={`flex items-center gap-x-[4px] ${justifyClass}`}>
      <FeatureImage image={lpImages.starIconYellow} className={sizeClass} />
      <FeatureImage image={lpImages.starIconYellow} className={sizeClass} />
      <FeatureImage image={lpImages.starIconYellow} className={sizeClass} />
      <FeatureImage image={lpImages.starIconYellow} className={sizeClass} />
      <FeatureImage image={lpImages.starIconYellow} className={sizeClass} />
    </div>
  )
}

export default Stars
